import type { Available } from "@b2bportal/rbc-additional-points-api";
import type { PointsToCashRedemption } from "@b2bportal/rbc-points-to-cash-api";
import type { FiatPrice, RewardsPrice } from "@hopper-b2b/types";

export enum RewardsSelectedOptionType {
  APPLY_POINTS = "applyPoints",
  SKIP_POINTS = "skipPoints",
}

export interface RewardsPaymentContext {
  rewardsSelectedState: RewardsSelectedOptionType;
  rewardsAmountToApply: RewardsPrice | undefined;
  rewardsAmountToApplyCashEquivalent: FiatPrice | undefined;
  /**
   * Authoritative points->cash redemption breakdown from
   * POST /api/v0/pointsToCash/quote. The ONLY source of truth for redemption
   * math (no multiplier fallback).
   */
  pointsRedemption?: PointsToCashRedemption;
  /** pointsToCash/quote fetch failed; redemption is not offered while true. */
  pointsToCashError?: boolean;
  /** pointsToCash/quote fetch is in flight; drives the rewards loading UI. */
  pointsToCashLoading?: boolean;
  error: boolean;
  rewardsAccountId: string;
  baseFareFixedPrice: RewardsPrice | undefined;
  additionalPointsPurchase?: Available | undefined;
  showAdditionalPointsNotEligibleModal: boolean;
  requiresTravelerRevalidation: boolean;
}

export const getInitialRewardsPaymentContext = (): RewardsPaymentContext => ({
  rewardsSelectedState: RewardsSelectedOptionType.APPLY_POINTS,
  rewardsAmountToApply: undefined,
  rewardsAmountToApplyCashEquivalent: undefined,
  pointsRedemption: undefined,
  pointsToCashError: false,
  pointsToCashLoading: false,
  error: false,
  rewardsAccountId: "",
  baseFareFixedPrice: undefined,
  additionalPointsPurchase: undefined,
  showAdditionalPointsNotEligibleModal: false,
  requiresTravelerRevalidation: false,
});
